export const defaultHeroBackgroundImage = (images, background) => {
  const backgroundImages = images
    .filter(ele =>
      [
        '1495f0LuHprVidWlYKVkuU',
        'RRDSN31hIl6gLin4qTAfL',
        '4cmbjg6gLkwPqlEyjh35ts',
        '32gRHoDZlO4nVjVCQ9QweN',
      ].includes(ele.node.contentful_id)
    )
    .map(ele => ele.node);

  const backgroundImage = backgroundImages.find(ele => ele.internalName.includes(background))
    ?.image;

  return backgroundImage;
};
